import { buildProps } from "@xplus/utils/props";
import type { ExtractPropTypes } from "vue";

export const popoverProps = buildProps({
  effect: {
    type: String,
    default: "light",
  },
  popperClass: {
    type: String,
    Array,
  },
} as const);

export type PopoverProps = ExtractPropTypes<typeof popoverProps>;
